import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import { VersionControlService } from '../../version-control/version-control.service';
import { AppState } from '../../model/reducer';
import { select, Store } from '@ngrx/store';
import _ from 'lodash';
import { Project } from '../project.model';
import { allProjectsView, selectedTenantKeyView, shouldDisplayTenantsView } from '../../model/views';

@Injectable()
export class ImportProjectContext {
  private versionControlService = inject(VersionControlService);
  private store$ = inject<Store<AppState>>(Store);

  projects$: Observable<Project[]>;
  selectedTenantKey$: Observable<string>;
  displayTenant$: Observable<boolean>;

  constructor() {
    this.projects$ = this.store$.pipe(select(allProjectsView), map(_.values));
    this.selectedTenantKey$ = this.store$.pipe(select(selectedTenantKeyView)) as Observable<string>;
    this.displayTenant$ = this.store$.pipe(select(shouldDisplayTenantsView));
  }
}
